export default __webpack_public_path__ + "static/media/blob3.0c4cbd0f.svg";